import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* saveRentalVehicle(action) {
  try {
    const rental = yield call(function() {
      return Api.post('/dealer/rental-vehicle', action.body)
    });
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
    yield put({type: 'SAVE_RENTAL_VEHICLE.SUCCESS', rental});
    yield put({type: 'HIDE_RENTAL_MODAL'});
    yield put({type: 'FETCH_RENTAL_VEHICLES.REQUEST', page: 0, size: 10});
  } catch(error) {
    yield put({type: 'SAVE_RENTAL_VEHICLE.FAILURE', error});
  }
}

function* updateRentalVehicle(action) {
  try {
    const rental = yield call(function() {
      return Api.put(`/dealer/rental-vehicle/${action.id}`, action.body)
    });
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
    yield put({type: 'UPDATE_RENTAL_VEHICLE.SUCCESS', rental});
    yield put({type: 'HIDE_RENTAL_MODAL'});
    yield put({type: 'FETCH_RENTAL_VEHICLES.REQUEST', page: 0, size: 10});
  } catch(error) {
    yield put({type: 'UPDATE_RENTAL_VEHICLE.FAILURE', error});
  }
}

function* deleteRentalVehicle(action) {
  const {parameters = {}} = action;
  try {
    const rental = yield call(function() {
      return Api.delete(`/dealer/rental-vehicle/${parameters.id}`);
    });
    yield put({type: 'DELETE_RENTAL_VEHICLE.SUCCESS', rental});
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
    yield put({type: 'FETCH_RENTAL_VEHICLES.REQUEST', page: 0, size: 10});
  } catch (error) {
    yield put({type: 'DELETE_RENTAL_VEHICLE.FAILURE', error});
  }
}

function* assignRentalVehicle(action) {
  const {body} = action;
  try {
    const rentalReporting = yield call(function () {
      return Api.post(`/assign-rental`, body);
    });
    yield put({type: 'ASSIGN_RENTAL_VEHICLE.SUCCESS'});
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
    yield put({type: 'HIDE_ASSIGN_MODAL'});
    yield put({type: 'FETCH.INTERVENTION.REQUEST', id: body.interventionId});
    yield put({type: 'FETCH_RENTAL_REPORTING.REQUEST', rentalDetailsId: rentalReporting.body.id})
  } catch (error) {
    yield put({type: 'ASSIGN_RENTAL_VEHICLE.FAILURE', error});
  }
}

function* fetchRentalContract(action) {
  try {
    const contract = yield call(function () {
      return Api.get(`/rental-details/${action.rentalDetailsId}`);
    });
    yield put({type: 'FETCH_RENTAL_CONTRACT.SUCCESS', contract});
  } catch (error) {
    yield put({type: 'FETCH_RENTAL_CONTRACT.FAILURE', error});
  }
}

function* unassignRentalVehicle(action) {
  try {
    const {id, interventionId} = action;
    yield call(function() {
      return Api.post(`/unassign-rental/${id}`);
    });
    yield put({type: 'UNASSIGN_RENTAL_VEHICLE.SUCCESS'});
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'action.delete.success'}});
    yield put({type: 'FETCH.INTERVENTION.REQUEST', id: interventionId});
  } catch (error) {
    yield put({type: 'UNASSIGN_RENTAL_VEHICLE.FAILURE', error});
  }
}

function* lookupVin(action){

  try {
    let ivsResults = [];
    if (action.vin && action.vin.length >= 4) {
      ivsResults = yield call(function () {
        return Api.get(`/ivs/${action.vin}`);
      });
    }
    yield put({type: 'LOOKUP_IVS_VIN.SUCCESS', ivsResults});
  } catch (error) {
    yield put({type: 'LOOKUP_IVS_VIN.FAILURE', error});
  }
}

export function* watchIvsLookup() {
  yield takeEvery('LOOKUP_IVS_VIN.REQUEST', lookupVin)
}


export function* watchSaveRentalVehicle() {
  yield takeEvery('SAVE_RENTAL_VEHICLE.REQUEST', saveRentalVehicle)
}

export function* watchUpdateRentalVehicle() {
  yield takeEvery('UPDATE_RENTAL_VEHICLE.REQUEST', updateRentalVehicle)
}

export function* watchDeleteRentalVehicle() {
  yield takeEvery('DELETE_RENTAL_VEHICLE.REQUEST', deleteRentalVehicle)
}

export function* watchAssignRentalVehicle() {
  yield takeEvery('ASSIGN_RENTAL_VEHICLE.REQUEST', assignRentalVehicle)
}

export function* watchFetchRentalContract() {
  yield takeEvery('FETCH_RENTAL_CONTRACT.REQUEST', fetchRentalContract)
}

export function* watchUnassignRentalVehicle() {
  yield takeEvery('UNASSIGN_RENTAL_VEHICLE.REQUEST', unassignRentalVehicle)
}
